import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getDisplayName } from "utils/hoc";

const makePersistMountedState = (WrappedComponent) => {
  const MountedStateComponent = (props) => {
    const { onMountStateChange, name } = props;

    useEffect(() => {
      // Inform about mounting
      onMountStateChange(name, true);

      // Inform about unmounting
      return () => onMountStateChange(name, false);
    }, [onMountStateChange, name]);

    return <WrappedComponent {...props} />;
  };

  MountedStateComponent.propTypes = {
    onMountStateChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  };

  MountedStateComponent.displayName = `MountedState${getDisplayName(
    WrappedComponent,
  )}`;

  return MountedStateComponent;
};

export default makePersistMountedState;
